import React from "react";

const Gift: React.FC = () => {
  return (
    <svg
      width={201}
      height={144}
      viewBox="0 0 201 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.3421 17.895L165.256 41.3613L155.976 138.359L17.3941 119.552L37.3421 17.895Z"
        fill="#FF6E00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.539 20.2878L154.828 -15.9006L191.891 31.0747L116.526 43.3555L114.342 52.4276L79.7778 44.4663L81.6074 34.6228L18.6357 -4.59776L71.7643 -30.2762L94.8072 15.777L113.539 20.2878Z"
        fill="#92D400"
      />
      <path
        d="M148.09 38.2121L116.526 43.3555L104.257 133.757L64.4344 128.353L80.6004 33.9954L62.0181 22.4218L148.09 38.2121Z"
        fill="#C3009E"
      />
    </svg>
  );
};

export default Gift;
